import HttpCliente from "../HttpCliente";

export const getNotificacionesBandeja = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/NotificacionesBandeja", {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const marcarNotificacionBandejaLeida = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put(`/NotificacionesBandeja/${id}/marcarLeida`, null, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const marcarTodasBandejaLeidas = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put("/NotificacionesBandeja/marcarTodasLeidas", null, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const eliminarNotificacionBandeja = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.delete(`/NotificacionesBandeja/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};